<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("add") }} {{ $t("globalloyaltysettings") }}
      </div>
      <router-link class="btn-blue" to="global-loyalty-settings"
        >{{ $t("globalloyaltysettings") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input
                v-model="ls_name"
                v-validate="'required'"
                placeholder="."
                type="text"
                name="loyaltysettingname"
                id="loyaltysettingname"
              />
              <label
                >{{ $t("global") }} {{ $t("loyaltysettings") }}
                {{ $t("name") }}</label
              >
            </div>
            <p
              v-if="submitted && errors.has('loyaltysettingname')"
              class="error_message"
            >
              <span>{{ errors.first("loyaltysettingname") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">{{ $t("initialamount") }} :</div>
              <div class="input-material-sm mx-2">
                <input
                class="text-right"
                  v-model="lnitial_load"
                  v-validate="'required|numeric'"
                  type="number"
                  name="initialload"
                  id="initialload"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('initialload')"
              class="error_message"
            >
              <span>{{ errors.first("initialload") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-3">{{ $t("expiry") }} {{ $t("value") }} :</div>
              <div class="input-material-sm mx-2">
                <input
                class="text-right"
                  v-model="expiry_value"
                  v-validate="'required|numeric'"
                  type="number"
                  name="expiryvalue"
                  id="expiryvalue"
                />
              </div>
            </div>
            <p
              v-if="submitted && errors.has('expiryvalue')"
              class="error_message"
            >
              <span>{{ errors.first("expiryvalue") }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="expiry_rule.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $t("duration") }}</label
                >
                <b-dropdown
                  :text="expiry_rule"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(levels, levelIndex) in levels"
                    :key="levelIndex"
                    @click="onSelectLevel(levels)"
                    >{{ levels }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
            <p
              v-if="submitted && expiry_rule.length == 0"
              class="error_message"
            >
              <span>{{ $t("please") }} {{ $t("select") }} {{ $t("duration") }}</span>
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-lg-12 align-self-center mb-4"
            v-for="(item, index) in loyalty_levels"
            :key="index"
          >
            <div class="row">
              <div class="col-md-10">
                <div class="row">
                  <div class="col-lg-6 col-xl-4 mb-4">
                    <div class="input-material">
                      <input
                        v-model="item.ll_name"
                        :id="'llname' + index"
                        v-validate="'required'"
                        placeholder="."
                        type="text"
                        name="loyaltylevelname"
                      />
                      <label :for="'llname' + index"
                        >{{ $t("global") }} {{ $t("loyaltysettings") }}
                        {{ $t("level") }}</label
                      >
                    </div>
                    <p
                      v-if="submitted && errors.has('loyaltylevelname')"
                      class="error_message"
                    >
                      <span>{{ errors.first("loyaltylevelname") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-4 mb-4">
                    <div class="row mx-0 align-items-center">
                      {{ $t("pointsrequired") }} :
                      <div class="input-material-sm mx-2">
                        <input
                        class="text-right"
                          v-model="item.points_required"
                          v-validate="'required|numeric'"
                          placeholder="."
                          type="number"
                          name="pointrquired"
                          id="pointrquired"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('pointrquired')"
                      class="error_message"
                    >
                      <span>{{ errors.first("pointrquired") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-4 mb-4">
                    <div class="row mx-0 align-items-center">
                      {{ $t("multiplepoints") }} :
                      <div class="input-material-sm mx-2">
                        <input
                        class="text-right"
                          v-model="item.multiple_points"
                          v-validate="'required'"
                          placeholder="."
                          type="number"
                          name="multiplepointsrquired"
                          id="multiplepointsrquired"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('multiplepointsrquired')"
                      class="error_message"
                    >
                      <span>{{ errors.first("multiplepointsrquired") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-4 mb-4">
                    <div class="row mx-0 align-items-center">
                      {{ $t("bonuspoints") }} :
                      <div class="input-material-sm mx-2">
                        <input
                        class="text-right"
                          v-model="item.bonus_points"
                          v-validate="'required'"
                          placeholder="."
                          type="number|numeric"
                          name="bonuspoint"
                          id="bonuspoint"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('bonuspoint')"
                      class="error_message"
                    >
                      <span>{{ errors.first("bonuspoint") }}</span>
                    </p>
                  </div>

                  <div class="col-md-6 mb-4">
                    <div class="row">
                      <div class="col-md-3 col-xl-2">
                        <label>{{ $t("active") }}</label>
                      </div>
                      <div class="col-md-9 col-xl-10">
                        <div>
                          <b-form-checkbox
                            v-model="item.ll_is_active"
                            name="check-button"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-2 d-flex align-items-center border-left">
                <div class>
                  <button
                    v-if="index == 0"
                    @click.prevent.stop="addLoyaltySettings()"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="25"
                      width="25"
                    />
                  </button>

                  <button
                    v-else
                    @click.prevent.stop="removeLoyaltySettings(index)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="25"
                      width="25"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-4">
        <div class="row">
          <div class="col-md-3 col-xl-2">
            <label>{{ $t("active") }}</label>
          </div>
          <div class="col-md-9 col-xl-10">
            <div>
              <b-form-checkbox
                v-model="ls_is_active"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="global-loyalty-settings"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      ls_name: "",
      expiry_rule: "",
      expiry_value: "",
      lnitial_load: "",
      ls_is_active: true,
      loyalty_levels: [
        {
          ll_name: "",
          points_required: "",
          multiple_points: "",
          bonus_points: "",
          ll_is_active: true
        }
      ],
      levels: ["Day", "Month", "Year"]
    };
  },
  methods: {
    resetHandler: function() {
      this.submitted = false;
      this.ls_name = "";
      this.expiry_rule = "";
      this.expiry_value = "";
      this.lnitial_load = "";
      this.ls_is_active = true;
      this.loyalty_levels = [
        {
          ll_name: "",
          points_required: "",
          multiple_points: "",
          bonus_points: "",
          ll_is_active: true
        }
      ];
    },
    onSelectLevel(params) {
      this.expiry_rule = params;
    },
    addLoyaltySettings: function() {
      this.loyalty_levels.push({
        ll_name: ""
      });
    },
    removeLoyaltySettings: function(index) {
      this.loyalty_levels.splice(index, 1);
    },

    OnFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (this.expiry_rule.length == 0) {
          return;
        }
        if (valid) {
          let payload = {
            ls_name: this.ls_name,
            expiry_rule: this.expiry_rule,
            expiry_value: this.expiry_value,
            lnitial_load: this.lnitial_load,
            ls_is_active: this.ls_is_active,
            loyalty_levels: this.loyalty_levels
          };

          MarketingService.AddGlobalLoyaltySettings(payload)
            .then(response => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.submitted = false;
                this.$router.push({
                  path: "/marketing/global-loyalty-settings"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
      // this.btenable = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/addgloballoyaltysettings.vue